import axios from 'axios'

const csrfToken = () => {
  const meta = document.getElementsByName('csrf-token')[0]
  return meta?.getAttribute('content')
}

const likePath = slug => `/api/internal/generator/community-models/${slug}/like`

const likersPath = slug => `/api/internal/generator/community-models/${slug}/likes`

// The BE exposes a singular like resource keyed on the run slug. GET is open to
// anonymous visitors (they always get `liked: false`); POST/DELETE require a
// session and 401 otherwise. All three echo the fresh `{ liked, likeCount }`.
//
// These call axios directly rather than going through useApiPost/useApiDelete
// because those capture every rejection to Sentry, and a 422 here is the
// expected "daily like limit reached" state, not an error worth reporting.
export const fetchCommunityModelLike = async (slug) => {
  const { data } = await axios.get(likePath(slug), { withCredentials: true })
  return data
}

// Paginated list of the users who liked a model (20 per page, JSON:API shaped -
// `data[]` plus `meta: { currentPage, perPage, totalItemsCount }`). Open to
// anonymous visitors, like GET on the singular resource above.
export const fetchCommunityModelLikers = async ({ slug, page = 1 }) => {
  const { data } = await axios.get(likersPath(slug), { params: { page }, withCredentials: true })
  return data
}

export const toggleCommunityModelLike = async ({ slug, liked }) => {
  const config = {
    headers: { 'X-CSRF-Token': csrfToken() },
    withCredentials: true,
  }

  const { data } = liked
    ? await axios.post(likePath(slug), {}, config)
    : await axios.delete(likePath(slug), config)

  return data
}

// The daily cap (AppSettings.likes.daily_limit) answers 422 and still returns a
// valid `{ liked, likeCount }` body, so it is a distinct outcome from a failure.
export const isDailyLimitError = error => error?.response?.status === 422
